import React from "react";
import { Modal, Image } from "react-bootstrap";

function MessageModal({
  src = "",
  name = "",
  content = "",
  onClose = () => {}
}) {
  return (
    <Modal
      size="sm"
      dialogClassName="message-modal"
      show={true}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Image src={src} rounded />
        <div
          className="message-owner-name"
          dangerouslySetInnerHTML={{
            __html: name
          }}
        />
      </Modal.Header>
      <Modal.Body>
        <span className="apostrophe start">&#8217;&#8217;</span>
        <div
          dangerouslySetInnerHTML={{
            __html: content
          }}
        />
        <span className="apostrophe end">&#8217;&#8217;</span>
      </Modal.Body>
    </Modal>
  );
}

export { MessageModal };
